/* Product page controller (variant pills, gallery, ppMix preview wiring, Globo price sync…). Moved out of
   sections/pp-main-product.liquid on 2026-10-03 so it is cached across product pages (~25KB per page view). */
(function () {
  var root = document.querySelector('[data-pp-pdp]');
  if (!root) return;

  // --- Variant select: update price + ATC label
  var select = root.querySelector('[data-pp-variant-select]');
  var priceEl = root.querySelector('[data-pp-price]');
  var priceWasEl = root.querySelector('[data-pp-price-was]');
  var discountChip = root.querySelector('[data-pp-discount-chip]');
  var atcPrice = root.querySelector('[data-pp-atc-price]');
  var stickyPrice = document.querySelector('[data-pp-sticky-price]');

  if (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var pf = opt.getAttribute('data-price-fmt');
      var cmpf = opt.getAttribute('data-cmp-fmt');
      var cmp = parseInt(opt.getAttribute('data-cmp') || '0', 10);
      var price = parseInt(opt.getAttribute('data-price') || '0', 10);
      if (priceEl) priceEl.textContent = pf;
      if (atcPrice) atcPrice.textContent = '· ' + pf;
      if (stickyPrice) stickyPrice.textContent = pf;
      if (priceWasEl) {
        if (cmp > price) { priceWasEl.textContent = cmpf; priceWasEl.style.display = 'inline'; }
        else { priceWasEl.style.display = 'none'; }
      }
      if (discountChip) {
        if (cmp > price) {
          discountChip.textContent = Math.round((cmp - price) * 100 / cmp) + '% OFF';
          discountChip.style.display = 'inline-flex';
        } else { discountChip.style.display = 'none'; }
      }
    });
  }

  // --- Finish / Style variant picker: set the form's variant id (+ price) on select.
  // Document-delegated + re-queried each click so it survives the product-options app
  // re-rendering the section (same reason the thumb gallery is bound on document).
  if (!window.__ppPdpVariantsBound) {
    window.__ppPdpVariantsBound = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-pp-variant]') : null;
      if (!b || b.classList.contains('is-soldout')) return;
      var sec = b.closest('[data-pp-pdp]') || document.querySelector('[data-pp-pdp]');
      if (!sec) return;
      var wrap = b.closest('[data-pp-variants]');
      if (wrap) {
        wrap.querySelectorAll('[data-pp-variant]').forEach(function (x) {
          x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false');
        });
      }
      b.classList.add('is-active'); b.setAttribute('aria-checked', 'true');
      var idInput = sec.querySelector('[data-pp-form] input[name="id"]') || sec.querySelector('[data-pp-id]');
      if (idInput) idInput.value = b.getAttribute('data-pp-variant');
      var pf = b.getAttribute('data-pp-price-fmt');
      if (pf) {
        var pe = sec.querySelector('[data-pp-price]'); if (pe) pe.textContent = pf;
        var ae = sec.querySelector('[data-pp-atc-price]'); if (ae) ae.textContent = '· ' + pf;
        var se = document.querySelector('[data-pp-sticky-price]'); if (se) se.textContent = pf;
      }
    });
  }

  // --- Mix & match preview (ppMix): recolour slide 1 (Style X in the oak frame) on a canvas to the chosen
  // style + frame colour. Coordinates are in the 1024x1366 centre crop of the 2048x1366 thumbnail template.
  if (!window.__ppMixBound) {
    window.__ppMixBound = true;
    var E = window.ppMixEngine, MIX = E.MIX, loadImg = E.loadImg, mixPrepare = E.prepare, mixRender = E.render;
    var mixCache = {}, mixSrc = null, mixPrep = null, mixBusy = null;
    // Slide 1 starts hidden (the page loads on "No Frame", not the framed thumbnail) and fades in once the
    // bare render is ready — or after 2.5s whatever happens, so the hero can never stay blank.
    var mixReveal = function (base) { var sl = base && base.closest('.pp-gal__slide'); if (sl) sl.classList.remove('is-mixing', 'is-peek'); };
    setTimeout(function () {
      var b = document.querySelector('[data-pp-mix-base]'), sl = b && b.closest('.pp-gal__slide');
      if (!sl) return;
      // A peek slide already shows the print, so a slow render needs no fallback; a hidden slide reveals.
      if (!sl.classList.contains('is-peek')) mixReveal(b);
    }, 4000);
    // Until the shopper touches anything, the preview is locked to the page's opening state: No Frame + the
    // style the page loaded on. Globo's own defaults and our scripted clicks (No Frame, variant sync) fire
    // untrusted events while loading and used to draw interim pictures (framed, or Square X before Y).
    var mixUser = false;
    var PP_COLOUR = { x: 'Stone', y: 'White', z: 'Mocha' };   // keep in step with snippets/pp-colour-name.liquid
    var mixInitPill = document.querySelector('[data-pp-pdp] [data-pp-variants] [data-pp-variant].is-active');
    var mixInitStyle = (mixInitPill && /^[xyz]$/.test(mixInitPill.getAttribute('data-pp-style'))) ? mixInitPill.getAttribute('data-pp-style') : '-';
    ['pointerdown', 'keydown'].forEach(function (t) {
      document.addEventListener(t, function (e) {
        if (e.isTrusted && e.target.closest && e.target.closest('[data-pp-variants], .gpo-container')) mixUser = true;
      }, true);
    });
    var mixState = function (sec) {
      if (!mixUser) return { style: mixInitStyle, frame: 'none', label: 'No' };
      var pill = sec.querySelector('[data-pp-variants] [data-pp-variant].is-active');
      var pst = pill ? pill.getAttribute('data-pp-style') : '';
      var style = /^[xyz]$/.test(pst) ? pst : '-';   // '-' = Matte/Satin/Gloss (picture unchanged)
      var shown = function (el) { var c = el.closest('.gpo-element') || el; return !!(c.offsetParent || el.offsetParent); };
      // Each size has its own Globo "Frame" choice ("<size> Framed" / "No Frame"). No Frame is the default,
      // so the print is shown bare unless a visible "... Framed" choice is ticked.
      var framed = false;
      document.querySelectorAll('.gpo-container input:checked').forEach(function (el) {
        if (el.name !== 'FrameColor' && shown(el) && /framed$/i.test(el.value.trim())) framed = true;
      });
      if (!framed) return { style: style, frame: 'none', label: 'No' };
      var fc = document.querySelector('.gpo-container input[name="FrameColor"]:checked');
      var label = fc ? fc.value : 'Wood';
      return { style: style, frame: label.toLowerCase(), label: label };
    };
    // Search / AI crawlers render JavaScript too. Swapping the hero to a browser-only blob: URL hid the real product
    // image from them (Google Images, Shop, AI answer engines). Crawlers keep the original CDN image; shoppers get
    // the live preview exactly as before. (2026-09-27)
    var mixIsBot = /bot|crawl|spider|slurp|google-inspectiontool|googleother|lighthouse|chrome-lighthouse|headless|gptbot|chatgpt|oai-searchbot|claudebot|claude-web|anthropic|perplexity|bingpreview|facebookexternalhit|pinterest/i.test(navigator.userAgent || '');
    var mixApply = function (userAction) {
      var sec = document.querySelector('[data-pp-pdp]');
      var base = sec && sec.querySelector('[data-pp-mix-base]');
      if (!base) return;
      if (mixIsBot) { mixReveal(base); return; }
      var st = mixState(sec);
      var key = st.style + '|' + st.frame;
      var chip = sec.querySelector('[data-pp-mix-chip]');
      if (chip) { chip.textContent = (PP_COLOUR[st.style] ? PP_COLOUR[st.style] + ' · ' : '') + st.label + ' frame'; chip.hidden = false; }
      if (userAction) {
        var track = sec.querySelector('[data-pp-gal-track]');
        if (track && track.scrollLeft > 2) track.scrollTo({ left: 0, behavior: 'smooth' });
      }
      if (!base.dataset.ppMixOrig) { base.dataset.ppMixOrig = base.getAttribute('src'); base.dataset.ppMixOrigSet = base.getAttribute('srcset') || ''; }
      if (!MIX.frames[st.frame] && st.frame !== 'none') { st.frame = 'wood'; key = st.style + '|wood'; }
      var tplCfg = MIX.tpl[base.getAttribute('data-pp-mix-tpl')];
      if (!tplCfg) return;
      if (!tplCfg.src) { st.style = '-'; key = '-|' + st.frame; }
      if (key === (tplCfg.src || '-') + '|wood' && !window.PP_PAGE) {
        base.dataset.ppMixWant = key;
        base.setAttribute('srcset', base.dataset.ppMixOrigSet); base.setAttribute('src', base.dataset.ppMixOrig);
        mixReveal(base);
        return;
      }
      var want = key;
      base.dataset.ppMixWant = want;
      var show = function (url) {
        if (!url || base.dataset.ppMixWant !== want) return;
        // Unmask/unblur only once the render has loaded (next frame), so the framed thumbnail can never show in
        // between. (img.decode() is not used: Chrome leaves it pending indefinitely on this page.)
        var done = function () { if (base.dataset.ppMixWant === want) requestAnimationFrame(function () { mixReveal(base); }); };
        base.removeAttribute('srcset');
        if (base.getAttribute('src') === url) { if (base.complete) done(); else base.addEventListener('load', done, { once: true }); return; }
        var settled = false, fin = function () { if (settled) return; settled = true; base.removeEventListener('load', fin); base.removeEventListener('error', fin); done(); };
        base.addEventListener('load', fin); base.addEventListener('error', fin);
        base.setAttribute('src', url);
        setTimeout(fin, 1500);
      };
      if (mixCache[key]) { show(mixCache[key]); return; }
      var src = base.getAttribute('data-pp-mix-src'), tpl = base.getAttribute('data-pp-mix-tpl');
      var onBad = function () { var c2 = sec.querySelector('[data-pp-mix-chip]'); if (c2) c2.hidden = true; mixReveal(base); };
      if (E.renderAsync) {
        // Off the main thread (Web Worker + OffscreenCanvas) when the browser can; falls back inside the engine.
        E.renderAsync(src, tpl, st.style, st.frame).then(function (r) {
          if (!r || r.bad) { onBad(); return; }
          if (!mixCache[key]) mixCache[key] = r.url;
          show(mixCache[key]);
        }).catch(function () { mixReveal(base); });
        return;
      }
      if (!mixPrep || mixSrc !== src) {
        mixSrc = src;
        mixBusy = loadImg(src).then(function (im) { mixPrep = mixPrepare(im, tpl); return mixPrep; });
      }
      mixBusy.then(function (prep) {
        if (prep.bad) { var c2 = sec.querySelector('[data-pp-mix-chip]'); if (c2) c2.hidden = true; mixReveal(base); return null; }
        if (mixCache[key]) return mixCache[key];
        return mixRender(prep, st.style, st.frame).then(function (url) { mixCache[key] = url; return url; });
      }).then(show).catch(function () { mixReveal(base); });
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-pp-variant]')) setTimeout(function () { mixApply(true); }, 0);
    });
    document.addEventListener('change', function (e) {
      var n = e.target && e.target.name || '';
      if (e.target.closest && e.target.closest('.gpo-container')) setTimeout(function () { mixApply(true); }, 60);
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.gpo-container')) setTimeout(function () { mixApply(false); }, 120);
    }, true);
    // Mobile mini preview: mirrors slide 1 in a floating card whenever the gallery is scrolled away and the
    // options are on screen, so choices can be judged without scrolling back up. Tap = full-screen view.
    (function () {
      var base = document.querySelector('[data-pp-mix-base]');
      var gal = document.querySelector('[data-pp-gal]');
      var opts = document.querySelector('[data-pp-form]') || document.querySelector('[data-pp-variants]');
      if (!base || !gal || !opts || !('IntersectionObserver' in window)) return;
      var mini = document.createElement('button');
      mini.type = 'button'; mini.className = 'pp-mix-mini'; mini.setAttribute('aria-label', 'Enlarge preview');
      mini.innerHTML = '<img alt=""><span></span>';
      // 2026-10-05: lives INSIDE the sticky add-to-basket bar (left of the price) instead of floating over the page —
      // floating bottom-left it covered the "No frame" card and the "Choose a colour" heading on phones.
      var bar = document.querySelector('.pp-sticky-atc__inner');
      if (bar) { mini.classList.add('pp-mix-mini--bar'); bar.insertBefore(mini, bar.firstChild); } else { document.body.appendChild(mini); }
      var mImg = mini.querySelector('img'), mTxt = mini.querySelector('span');
      var chip = document.querySelector('[data-pp-mix-chip]');
      var galVis = true, optVis = false;
      var sync = function (bump) {
        var src = base.currentSrc || base.getAttribute('src');
        if (src && mImg.getAttribute('src') !== src) mImg.setAttribute('src', src);
        mTxt.textContent = chip && !chip.hidden ? chip.textContent : '';
        if (bump && mini.classList.contains('is-on')) { mini.classList.remove('is-bump'); void mini.offsetWidth; mini.classList.add('is-bump'); }
      };
      var toggle = function () { mini.classList.toggle('is-on', !galVis && optVis && !base.closest('.is-mixing')); };
      new IntersectionObserver(function (en) { galVis = en[0].isIntersecting; toggle(); }, { threshold: 0.15 }).observe(gal);
      new IntersectionObserver(function (en) { optVis = en[0].isIntersecting; toggle(); }, { threshold: 0 }).observe(opts);
      new MutationObserver(function () { sync(true); toggle(); }).observe(base, { attributes: true, attributeFilter: ['src'] });
      if (chip) new MutationObserver(function () { sync(false); }).observe(chip, { childList: true, characterData: true, subtree: true });
      base.addEventListener('load', function () { sync(false); });
      sync(false);
      mini.addEventListener('click', function () {
        var z = document.createElement('div'); z.className = 'pp-mix-zoom'; z.setAttribute('role', 'dialog');
        z.innerHTML = '<img alt=""><p></p><button type="button">Back to options</button>';
        z.querySelector('img').src = base.currentSrc || base.src;
        z.querySelector('p').textContent = mTxt.textContent;
        var close = function () { z.remove(); };
        z.addEventListener('click', close);
        document.body.appendChild(z);
      });
    })();
    mixApply(false);
    if (document.readyState !== 'complete') window.addEventListener('load', function () { mixApply(false); });
    // Globo renders its options after load; pick up its default frame colour when it appears
    setTimeout(function () { mixApply(false); }, 2500);
  }

  // --- Gallery (swipe track + arrows + thumbnails). Document-delegated so it survives Globo re-rendering
  // the section; the active slide is always computed from the track's scroll position.
  if (!window.__ppGalBound) {
    window.__ppGalBound = true;
    var galOf = function (el) { return el && el.closest ? el.closest('[data-pp-pdp]') : null; };
    var galParts = function (sec) {
      var track = sec && sec.querySelector('[data-pp-gal-track]');
      return track ? { sec: sec, track: track, slides: track.querySelectorAll('[data-pp-gal-slide]') } : null;
    };
    var galIndex = function (g) { return g.track.clientWidth ? Math.round(g.track.scrollLeft / g.track.clientWidth) : 0; };
    var galGo = function (g, i) {
      i = Math.max(0, Math.min(g.slides.length - 1, i));
      var target = i * g.track.clientWidth;
      g.track.scrollTo({ left: target, behavior: 'smooth' });
      // Safety net: smooth scrolling can stall (background tabs, low-power phones) — if the slide
      // hasn't arrived shortly after, jump straight to it so a click always lands.
      clearTimeout(g.track.__ppGoTimer);
      g.track.__ppGoTimer = setTimeout(function () {
        if (Math.abs(g.track.scrollLeft - target) > 2) {
          g.track.style.scrollBehavior = 'auto';
          g.track.scrollLeft = target;
          g.track.style.scrollBehavior = '';
          galSync(g);
        }
      }, 600);
    };
    var galSync = function (g) {
      var i = galIndex(g), n = g.slides.length;
      // Off-screen slides are served small (sizes 45vw) until the shopper reaches them: slides 2–3 used to download
      // at 800w (180KB on a phone) just for sitting next to slide 1 in the scroll-snap track (2026-10-05).
      for (var k = 0; k < n; k++) {
        if (Math.abs(k - i) > 1) continue;
        var im = g.slides[k].querySelector('img[data-pp-full-sizes]');
        if (im) { im.sizes = im.getAttribute('data-pp-full-sizes'); im.removeAttribute('data-pp-full-sizes'); }
      }
      g.sec.querySelectorAll('[data-pp-gal-go]').forEach(function (b) {
        var on = +b.getAttribute('data-pp-gal-go') === i;
        b.classList.toggle('is-active', on);
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      var prev = g.sec.querySelector('[data-pp-gal-prev]'), next = g.sec.querySelector('[data-pp-gal-next]');
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
      var c = g.sec.querySelector('[data-pp-gal-count]');
      if (c) c.textContent = (i + 1) + ' / ' + n;
    };
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-pp-gal-go], [data-pp-gal-prev], [data-pp-gal-next]');
      if (!t) return;
      var g = galParts(galOf(t));
      if (!g) return;
      if (t.hasAttribute('data-pp-gal-go')) galGo(g, +t.getAttribute('data-pp-gal-go'));
      else galGo(g, galIndex(g) + (t.hasAttribute('data-pp-gal-next') ? 1 : -1));
    });
    // Debounced with a timer (not rAF, which low-power phones and background tabs pause) so the
    // counter and thumbnails always catch up with a swipe.
    var galTimer = null;
    document.addEventListener('scroll', function (e) {
      var tr = e.target;
      if (!tr || !tr.matches || !tr.matches('[data-pp-gal-track]')) return;
      clearTimeout(galTimer);
      galTimer = setTimeout(function () { var g = galParts(galOf(tr)); if (g) galSync(g); }, 50);
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var tr = e.target.closest && e.target.closest('[data-pp-gal-track]');
      if (!tr) return;
      var g = galParts(galOf(tr));
      if (!g) return;
      e.preventDefault();
      galGo(g, galIndex(g) + (e.key === 'ArrowRight' ? 1 : -1));
    });
    // No resize handler: scroll-snap re-snaps to the same slide on layout changes by itself, and phones
    // fire resize constantly while scrolling (URL bar), which used to yank the gallery back to slide 1.
  }

  // --- Default the Globo size to A5 (the base price), so the £ shown on load is clearly the A5
  // price rather than an unexplained "from" figure. Only when the shopper hasn't picked a size;
  // Globo renders after load, so poll briefly for its radios.
  if (!window.__ppGpoDefaultSize) {
    window.__ppGpoDefaultSize = true;
    var ppSizeTries = 0;
    var ppSizeTimer = setInterval(function () {
      var sizes = document.querySelectorAll('.gpo-container input[name="Size"]');
      if (sizes.length) {
        clearInterval(ppSizeTimer);
        var picked = Array.prototype.some.call(sizes, function (i) { return i.checked; });
        if (!picked) {
          var a5 = document.querySelector('.gpo-container input[name="Size"][value="A5"]') || sizes[0];
          if (a5 && !a5.disabled) a5.click();
        }
      } else if (++ppSizeTries > 80) {
        clearInterval(ppSizeTimer);
      }
    }, 150);
  }

  // --- Frame defaults to "No Frame": whenever a size's Frame choice is on screen with nothing picked,
  // pick "No Frame" (via its label, so Globo registers it) — the framed add-on stays one tap away.
  // Each size has its OWN Frame choice in Globo, so changing size used to drop a framed pick back to No Frame and
  // lose the frame colour (Harry 2026-11-03). The shopper's last frame pick and colour are remembered and carried
  // over to the new size's Frame choice instead.
  if (!window.__ppGpoNoFrame) {
    window.__ppGpoNoFrame = true;
    var ppWantFramed = false, ppWantColour = '';
    var ppNoFrame = function () {
      document.querySelectorAll('.gpo-container .gpo-element').forEach(function (el) {
        var nf = el.querySelector('input[value="No Frame"]');
        if (!nf || !el.offsetParent) return;
        if (el.querySelector('input:checked')) return;
        var pick = nf;
        if (ppWantFramed) {
          var fr = Array.prototype.find.call(el.querySelectorAll('input'), function (i) { return /framed$/i.test(i.value.trim()) && !i.disabled; });
          if (fr) pick = fr;
        }
        var lb = el.querySelector('label[for="' + pick.id + '"]') || pick.nextElementSibling;
        if (lb) lb.click(); else pick.click();
      });
    };
    // Picking a framed option pre-selects the shopper's last frame colour, else Wood (oak, "Popular"), if none is chosen yet.
    var ppWood = function () {
      var fc = document.querySelectorAll('.gpo-container input[name="FrameColor"]');
      if (!fc.length || Array.prototype.some.call(fc, function (i) { return i.checked; })) return;
      var el = fc[0].closest('.gpo-element'); if (el && !el.offsetParent) return;
      var wood = (ppWantColour && document.querySelector('.gpo-container input[name="FrameColor"][value="' + ppWantColour + '"]')) ||
        document.querySelector('.gpo-container input[name="FrameColor"][value="Wood"]');
      if (!wood) return;
      var lb = document.querySelector('label[for="' + wood.id + '"]') || wood.nextElementSibling;
      if (lb) lb.click(); else wood.click();
    };
    document.addEventListener('change', function (e) {
      if (!e.target) return;
      var v = (e.target.value || '').trim();
      if (e.target.name === 'FrameColor') ppWantColour = v;
      else if (v === 'No Frame') ppWantFramed = false;
      else if (/framed$/i.test(v)) ppWantFramed = true;
      if (e.target.name === 'Size') { setTimeout(ppNoFrame, 60); setTimeout(ppNoFrame, 300); }
      if (/framed$/i.test((e.target.value || '').trim())) { setTimeout(ppWood, 60); setTimeout(ppWood, 300); }
    });
    var ppNfTries = 0;
    var ppNfTimer = setInterval(function () {
      if (document.querySelector('.gpo-container input[value="No Frame"]') || ++ppNfTries > 80) { clearInterval(ppNfTimer); ppNoFrame(); }
    }, 150);
  }

  // --- Globo Product Options price sync
  // Globo (size / frame add-ons) shows its own "Selections will add £X to the price"
  // total (.gpo-total .money) but never updates the theme's price or ATC button — so
  // the page kept showing the base price while the cart charged base + add-ons.
  // Mirror it: displayed price = current variant price + Globo's add-on total,
  // recomputed whenever Globo's widget mutates or the variant changes.
  if (!window.__ppGpoPriceSync) {
    window.__ppGpoPriceSync = true;
    // Shopper's currency (2026-10-03): shop.money_format was the shop's GBP format, so US visitors saw "£" on
    // dollar amounts once Globo changed the price.
    var ppInitialCents = window.ppPdpInitialCents || 0;
    var ppCur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    var ppFmtMoney = function (cents) {
      try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: ppCur, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2) + ' ' + ppCur; }
    };
    var ppBaseCents = function () {
      var pill = document.querySelector('[data-pp-variants] [data-pp-variant].is-active[data-pp-price]');
      if (pill) { var pv = parseInt(pill.getAttribute('data-pp-price'), 10); if (pv) return pv; }
      var sel = document.querySelector('[data-pp-variant-select]');
      if (sel && sel.options[sel.selectedIndex]) {
        var p = parseInt(sel.options[sel.selectedIndex].getAttribute('data-price') || '0', 10);
        if (p) return p;
      }
      return ppInitialCents;
    };
    var ppAddonCents = function () {
      // No visibility check: Globo's .money offsetParent is unreliably null even when
      // shown, but Globo CLEARS the text whenever no add-on is selected — so empty/
      // unparseable text is the authoritative "no add-on" signal.
      var el = document.querySelector('.gpo-total .money') || document.querySelector('.gpo-total');
      if (!el) return 0;
      // Amounts follow the shopper's currency: "€20,78", "1 619,90 CVE", "CHF 1'234.50". Spaces and apostrophes group
      // thousands; a separator followed by 1-2 digits at the end is the decimal point.
      var m = (el.textContent || '').match(/\d[\d.,'\s\u00a0\u202f]*/);
      if (!m) return 0;
      var n = m[0].replace(/['\s\u00a0\u202f]/g, '').replace(/[.,]$/, '');
      n = /[.,]\d{1,2}$/.test(n) ? n.replace(/[.,](\d{1,2})$/, 'D$1').replace(/[.,]/g, '').replace('D', '.') : n.replace(/[.,]/g, '');
      return Math.round(parseFloat(n) * 100) || 0;
    };
    var ppTick = null;
    var ppApply = function () {
      ppTick = null;
      var fmt = ppFmtMoney(ppBaseCents() + ppAddonCents());
      var pe = document.querySelector('[data-pp-price]');
      var ae = document.querySelector('[data-pp-atc-price]');
      var se = document.querySelector('[data-pp-sticky-price]');
      // only write on change — a same-value write would re-trigger the observer forever
      if (pe && pe.textContent !== fmt) pe.textContent = fmt;
      if (ae && ae.textContent !== '· ' + fmt) ae.textContent = '· ' + fmt;
      if (se && se.textContent !== fmt) se.textContent = fmt;
    };
    var ppQueue = function () { if (!ppTick) ppTick = setTimeout(ppApply, 60); };
    // Globo renders after load (and may re-render); a body-wide observer with a
    // debounced, change-guarded apply is the only hook that survives all of it.
    new MutationObserver(ppQueue).observe(document.body, {
      subtree: true, childList: true, characterData: true,
      attributes: true, attributeFilter: ['class', 'style']
    });
    // variant changes (pills or select) re-set the base price — recompute after their handlers
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-pp-variant]')) ppQueue();
    });
    document.addEventListener('change', ppQueue);
  }

  // --- Gift note: live character count; an empty note is disabled so it isn't sent as a blank property
  var giftTa = root.querySelector('[data-pp-gift]');
  if (giftTa && !giftTa.__pp) {
    giftTa.__pp = true;
    var giftCount = root.querySelector('[data-pp-gift-count]');
    var giftSync = function () {
      if (giftCount) giftCount.textContent = String(250 - giftTa.value.length);
    };
    giftTa.addEventListener('input', giftSync);
    var giftForm = giftTa.closest('form');
    if (giftForm) giftForm.addEventListener('submit', function () {
      giftTa.disabled = !giftTa.value.trim();
      setTimeout(function () { giftTa.disabled = false; }, 0);
    }, true);
  }

  // --- Sticky ATC: show when buy-box ATC scrolls out of view
  var sticky = document.querySelector('[data-pp-sticky]');
  var buyAtc = root.querySelector('[data-pp-atc]');
  var form = root.querySelector('[data-pp-form]');
  if (sticky && buyAtc && form) {
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      sticky.setAttribute('data-visible', visible ? 'false' : 'true');
      sticky.setAttribute('aria-hidden', visible ? 'true' : 'false');
      sticky.inert = visible; // not tabbable while hidden
    }, { rootMargin: '-80px 0px 0px 0px' });
    io.observe(buyAtc);

    var stickyBtn = sticky.querySelector('[data-pp-sticky-atc]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }
})();
